import type { CoinsFeatureInfo } from "../../aysa_api/models/coins_feature_info.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseImage,
  encodeImage,
  decodeImage,
} from "../../aysa_api/models/image";

export const createBaseCoinsFeatureInfo = (): CoinsFeatureInfo => {
  return {
    title: "",
    description: "",
    icon: createBaseImage(),
  };
};

export const decodeCoinsFeatureInfo = (
  reader: Reader,
  length: number
): CoinsFeatureInfo => {
  const end = reader.pos + length;
  const message = createBaseCoinsFeatureInfo();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.title = reader.string();

        break;
      case 2:
        message.description = reader.string();

        break;
      case 3:
        message.icon = decodeImage(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCoinsFeatureInfo = (
  writer: Writer,
  message: CoinsFeatureInfo
): Writer => {
  writer.uint32(10).string(message.title);
  writer.uint32(18).string(message.description);
  encodeImage(writer.uint32(26).fork(), message.icon).ldelim();

  return writer;
};
